import clsx from 'clsx';

export const section = clsx(
  'px-10',
  'py-20',
  'md:px-48',
  'md:py-50',
  'bg-background',
  'text-center'
);

export const container = clsx(
  'flex',
  'flex-col',
  'md:flex-row',
  'md:gap-12',
  'items-center',
  'justify-center'
);

export const image = clsx(
  'rounded-2xl',
  'shadow-lg',
  'w-full',
  'max-w-72',
  'md:max-w-md',
  'mb-10',
  'md:mb-0',
  'object-contain'
);

export const content = clsx(
  'flex',
  'flex-col'
);

export const titleText = clsx(
  'title',
  'text-[26px]',
  'md:text-3xl',
  'font-semibold',
  'mb-6',
  'text-title',
  'text-center',
  'md:text-left'
);

export const descriptionText = clsx(
  'font-subtitle',
  'text-[14px]',
  'md:text-[15px]',
  'text-description',
  'mb-4',
  'text-center',
  'md:text-left',
  'tracking-normal'
);
